import { render, staticRenderFns } from "./modal-social-transfer-primary-admin.vue?vue&type=template&id=38701542&scoped=true&lang=pug"
import script from "./modal-social-transfer-primary-admin.js?vue&type=script&lang=js&external"
export * from "./modal-social-transfer-primary-admin.js?vue&type=script&lang=js&external"
import style0 from "./modal-social-transfer-primary-admin.vue?vue&type=style&index=0&id=38701542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38701542",
  null
  
)

export default component.exports